import { MenuList } from '@mui/material';
import Paper from '@mui/material/Paper';
import CustomPopover from 'common/components/PopoversAndDialogs/CustomPopover';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

import SettingsMenuItem from 'common/features/settingsMenu/components/SettingsMenuItem';
import useFlexBoxStyles from 'common/flexBox';
import { makeStyles } from 'tss-react/mui';
import ShortVideoSettingsMedia from './ShortVideoSettingsMedia';

const useStyles = makeStyles()((theme) => {
    return {
        root: {
            minWidth: theme.spacing(20),
        },
    };
});

const ShortVideoSettingsMenu = (props) => {
    const { open, handleOnClose, anchorEl } = props;

    const { classes, cx } = useStyles();
    const { classes: flexBox } = useFlexBoxStyles();

    const { t } = useTranslation();
    const [anchorElMedia, setAnchorElMedia] = useState(null);
    const [openMedia, setOpenMedia] = useState();

    const handleListKeyDown = useCallback(
        (event) => {
            if (event.key === 'Tab') {
                event.preventDefault();
                handleOnClose();
            }
        },
        [handleOnClose],
    );

    const handleCameraClicked = (event) => {
        setAnchorElMedia(event.currentTarget);
        setOpenMedia('videoinput');
    };

    const handleMicClicked = (event) => {
        setAnchorElMedia(event.currentTarget);
        setOpenMedia('audioinput');
    };

    const handleCloseMedia = () => {
        setOpenMedia();
        setAnchorElMedia(null);
    };

    return (
        <>
            <CustomPopover
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                hideCloseButton={true}
                anchorEl={anchorEl}
                open={open}
                handleOnClose={handleOnClose}
                disablePortal={true}
            >
                <Paper className={cx(classes.root, flexBox.borderRadius2, flexBox.overflowHidden)}>
                    <MenuList
                        autoFocusItem={open}
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                        className={flexBox.padding0}
                    >
                        <SettingsMenuItem
                            id="onlive-menu-item-setting-language"
                            submenu={true}
                            onClick={handleCameraClicked}
                            selected={openMedia === 'videoinput'}
                        >
                            {t('shortVideo.form.camera')}
                        </SettingsMenuItem>
                        <SettingsMenuItem
                            id="onlive-menu-item-setting-language"
                            submenu={true}
                            onClick={handleMicClicked}
                            selected={openMedia === 'audioinput'}
                        >
                            {t('shortVideo.form.mic')}
                        </SettingsMenuItem>
                    </MenuList>
                </Paper>
            </CustomPopover>

            {Boolean(openMedia) && (
                <ShortVideoSettingsMedia type={openMedia} handleOnClose={handleCloseMedia} anchorEl={anchorElMedia} />
            )}
        </>
    );
};

export default ShortVideoSettingsMenu;
